import { hot } from 'react-hot-loader';
import React from 'react';
import { renderRoutes } from 'react-router-config';
import { createGlobalStyle } from 'styled-components';

import Layout from './layout';

const Global = createGlobalStyle`
  *,
  *:before,
  *:after {
      box-sizing: border-box;
  }

  body {
    background-color: white;
  }
`;

function App({ route, config }) {
  return (
    <>
      <Global />
      <Layout>{route && renderRoutes(route.routes, { config })}</Layout>
    </>
  );
}

export default hot(module)(App);
